module.exports = __webpack_public_path__ + "static/media/content_2.ba30a377.svg";